import './SelectBlocoItemFormulario.css';

import { useEffect, useState } from 'react';
import { servGetAllBlocoItem } from '../../servicos/bloco_item_formulario';

function SelectBlocoItemFormulario({ setBlocoItem }) {

    const [blocosItemList, setblocosItemList] = useState([])

    useEffect(() => {
        getAllBlocoItem()
    }, []);

    const getAllBlocoItem = async () => {
        try {
            const blocosItemDaApi = await servGetAllBlocoItem()
            setblocosItemList(blocosItemDaApi)
        } catch (erro) {
            console.log(erro);
        }
    }

    const handleChange = (e) => {
        const value = e.target.value || null; // Se for "" transforma em null
        setBlocoItem(value)
    };

    return (
        <div>
            {blocosItemList ? (
                <div className="d-flex flex-column flex-md-row gap-1 p-1 align-items-center">
                    <label htmlFor="blocoItem" className="text-nowrap">Bloco Item</label>
                    <select
                        className="selectBlocoItem form-select form-select-sm w-100"
                        id="blocoItem"
                        defaultValue=""
                        onChange={handleChange}
                    >
                        <option value="">Selecione uma opção</option>
                        {blocosItemList.map((blocoItem) => (
                            <option key={blocoItem.id} value={blocoItem.id}>
                                {blocoItem.descricao}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <p>Carregando informações dos blocos de perguntas...</p>
            )}
        </div>
    )
}

export default SelectBlocoItemFormulario